/* Royal Deccan Wishlist | Browser-only, no cookies and no external libraries. */
(function () {
  'use strict';
  if (window.RoyalDeccanWishlist) return;
  var KEY = 'royal-deccan-wishlist-v1';
  var LIMIT = 100;
  var canStore = true;
  var items = [];
  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter(function(p){return p && typeof p.handle === 'string' && /^[a-z0-9-]+$/i.test(p.handle);}).slice(0,LIMIT) : [];
    } catch(e) {canStore=false;return [];}
  }
  function write() {
    if (!canStore) return false;
    try {window.localStorage.setItem(KEY, JSON.stringify(items));return true;}
    catch(e) {canStore=false;return false;}
  }
  function safeHref(url) {
    try {
      var p = new URL(String(url||''),window.location.origin);
      if (p.origin !== window.location.origin || !/\/products\/[^/]+/.test(p.pathname)) return '';
      return p.pathname + p.search;
    } catch(e) {return '';}
  }
  function safeImage(url) {
    try {
      var p = new URL(String(url||''),window.location.origin);
      return (p.protocol==='https:' || (p.protocol==='http:' && p.origin===window.location.origin)) ? p.href : '';
    } catch(e) {return '';}
  }
  function has(handle) {return items.some(function(p){return p.handle===handle;});}
  function updateHearts() {
    document.querySelectorAll('[data-rdw-toggle]').forEach(function(b){
      var selected=has(b.getAttribute('data-rdw-handle'));
      b.classList.toggle('is-saved',selected);
      b.setAttribute('aria-pressed',selected?'true':'false');
      b.setAttribute('aria-label',(selected?'Remove ':'Add ')+(b.getAttribute('data-rdw-title')||'product')+(selected?' from':' to')+' wishlist');
      b.title=selected?'Remove from wishlist':'Add to wishlist';
    });
    document.querySelectorAll('[data-rdw-count]').forEach(function(c){
      c.textContent=items.length>99?'99+':String(items.length);
      c.hidden=items.length===0;
    });
    document.querySelectorAll('[data-rdw-header]').forEach(function(el){
      el.setAttribute('aria-label','Wishlist ('+items.length+' items)');
      el.classList.toggle('has-items',items.length>0);
    });
  }
  function makeProductFromButton(btn) {
    var handle=(btn.getAttribute('data-rdw-handle')||'').trim();
    var href=safeHref(btn.getAttribute('data-rdw-url'));
    if(!/^[a-z0-9-]+$/i.test(handle) || !href)return null;
    return {handle:handle,url:href,title:(btn.getAttribute('data-rdw-title')||handle).slice(0,250),image:safeImage(btn.getAttribute('data-rdw-image')),price:(btn.getAttribute('data-rdw-price')||'').slice(0,80)};
  }
  function addOrRemove(btn){
    var p=makeProductFromButton(btn);if(!p)return;
    if(has(p.handle)) {items=items.filter(function(x){return x.handle!==p.handle;});}
    else {if(items.length>=LIMIT){ window.alert('Wishlist limit reached ('+LIMIT+' products).');return;}items.unshift(p);}
    if(!write()){items=read();window.alert('Your browser cannot save the wishlist. Please enable browser storage.');}
    updateHearts();
    if(has(p.handle)){
      btn.classList.remove('is-pop');void btn.offsetWidth;btn.classList.add('is-pop');
      window.setTimeout(function(){btn.classList.remove('is-pop');},470);
      document.querySelectorAll('[data-rdw-header]').forEach(function(icon){
        icon.classList.remove('is-pop');void icon.offsetWidth;icon.classList.add('is-pop');
        window.setTimeout(function(){icon.classList.remove('is-pop');},470);
      });
    }
    renderWishlistPage();
  }
  function elem(tag,className,text){
    var e=document.createElement(tag); if(className)e.className=className;
    if(text!==undefined && text!==null)e.textContent=String(text);return e;
  }
  function createPageCard(p){
    var card=elem('article','rd-wishlist-page__card');
    var imgLink=elem('a','rd-wishlist-page__image-link');imgLink.href=p.url;
    if(p.image){var pic=elem('img');pic.src=p.image;pic.alt=p.title;pic.loading='lazy';pic.decoding='async';imgLink.appendChild(pic);}
    card.appendChild(imgLink);
    var remove=elem('button','rd-wishlist-button is-saved');remove.type='button';
    remove.setAttribute('data-rdw-toggle','');
    remove.setAttribute('data-rdw-handle',p.handle);
    remove.setAttribute('data-rdw-title',p.title);
    remove.setAttribute('data-rdw-url',p.url);
    remove.setAttribute('data-rdw-image',p.image||'');
    remove.setAttribute('data-rdw-price',p.price||'');
    remove.setAttribute('aria-label','Remove '+p.title+' from wishlist');
    remove.setAttribute('aria-pressed','true');
    remove.title='Remove from wishlist';
    remove.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.8a5.5 5.5 0 0 0-7.8 0L12 5.9l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.4a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
    card.appendChild(remove);
    var title=elem('h3','rd-wishlist-page__product-title');
    var a=elem('a','',p.title);a.href=p.url;title.appendChild(a);card.appendChild(title);
    if(p.price)card.appendChild(elem('p','rd-wishlist-page__price',p.price));
    var view=elem('a','rd-wishlist-page__product-link','View Product →');view.href=p.url;card.appendChild(view);
    return card;
  }
  function renderWishlistPage(){
    document.querySelectorAll('[data-rdw-page]').forEach(function(page){
      var grid=page.querySelector('[data-rdw-grid]'),empty=page.querySelector('[data-rdw-empty]');
      if(!grid||!empty)return;
      grid.replaceChildren();
      items.forEach(function(p){grid.appendChild(createPageCard(p));});
      grid.hidden=items.length===0;
      empty.hidden=items.length!==0;
    });
  }
  function injectDawnCardButtons(root) {
    if(!root.querySelectorAll)return;
    root.querySelectorAll('.card-wrapper').forEach(function(card){
      var dest=card.querySelector('.card__inner');
      if(!dest || dest.querySelector('[data-rdw-toggle]'))return;
      var link=card.querySelector('a[href*="/products/"]');
      if(!link)return;
      var href=safeHref(link.getAttribute('href'));
      if(!href)return;
      var m=href.match(/\/products\/([^/?#]+)/);if(!m)return;
      var titleEl=card.querySelector('.card__heading');
      var title=(titleEl?titleEl.textContent:link.textContent||'').trim()||m[1];
      var img=card.querySelector('.card__media img');
      var priceEl=card.querySelector('.price-item--sale')||card.querySelector('.price-item--regular');
      var btn=elem('button','rd-wishlist-button');btn.type='button';
      btn.setAttribute('data-rdw-toggle','');btn.setAttribute('data-rdw-handle',m[1]);
      btn.setAttribute('data-rdw-title',title);btn.setAttribute('data-rdw-url',href);
      btn.setAttribute('data-rdw-image',img?(img.currentSrc||img.src):'');
      btn.setAttribute('data-rdw-price',priceEl?priceEl.textContent.trim():'');
      btn.setAttribute('aria-pressed','false');btn.setAttribute('aria-label','Add '+title+' to wishlist');
      btn.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.8a5.5 5.5 0 0 0-7.8 0L12 5.9l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.4a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
      dest.appendChild(btn);
    });
  }
  function refresh(root){injectDawnCardButtons(root||document);updateHearts();renderWishlistPage();}
  items=read();
  window.RoyalDeccanWishlist={getItems:function(){return items.slice();},refresh:function(){refresh(document);}};
  document.addEventListener('click',function(ev){
    var btn=ev.target.closest('[data-rdw-toggle]');if(!btn)return;
    ev.preventDefault();ev.stopPropagation();addOrRemove(btn);
  });
  window.addEventListener('storage',function(e){if(e.key===KEY){canStore=true;items=read();refresh(document);}});
  document.addEventListener('shopify:section:load',function(e){refresh(e.target);});
  document.addEventListener('shopify:section:reorder',function(){refresh(document);});
  function init(){refresh(document);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
